import { emit } from '@emotive/emitter';
import { useEffect, useState } from 'react';
import { useQueryString } from '../hooks/useQueryString';
import { useAPIContext, useRedirectorContext } from '../services';
import { extractHTMLValue } from '../utils';
import LoginForm from './login-form/form';

const Login = () => {
  const api = useAPIContext();
  const redirect = useRedirectorContext();

  const [error, setError] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [resetting, setResetting] = useState(false);

  const values = useQueryString();

  useEffect(() => {
    window.localStorage.removeItem('$$CLAIMS$$');
  }, []);

  const handleLogin = async ({
    recaptchaToken,
    username,
    email,
    password,
    shopify,
    next = '',
    isShopifyEmbedded = false,
    shopifyLogin,
  }) => {
    if (submitting) {
      return false;
    }

    /**
     * If the request comes from the Shopify embedded
     * app, we need to pull off the necessary params and re-inject them
     * into the redirect URL.
     **/
    const buildNextUriParams = () => {
      if (!isShopifyEmbedded) return '';

      const { session, locale, timestamp, hmac, shop, host } = values;
      const stringifiedParams = new URLSearchParams({
        host,
        session,
        locale,
        timestamp,
        hmac,
        shop,
      }).toString();

      return `?${stringifiedParams}`;
    };

    try {
      setError(false);
      setSubmitting(true);
      setResetting(false);

      if (shopifyLogin) {
        const authOrigin = extractHTMLValue('#authOrigin');
        const shopifyUrl = `${authOrigin}/auth/v2/shopify/auth?shop=${shopify}`;

        emit('logEvent:Logged In', { loginType: 'shopify' });

        redirect(shopifyUrl);
      } else {
        await api.login({
          recaptchaToken,
          username,
          email,
          password,
          isShopifyEmbedded,
        });
        const redirectParams = buildNextUriParams();
        const redirectUri = next + redirectParams;

        emit('logEvent:Logged In', {
          loginType: username ? 'username' : 'email',
        });

        redirect(redirectUri || '/');
      }
    } catch (err) {
      setError(true);
      setSubmitting(false);
      setResetting(true);
    }
  };

  return (
    <LoginForm
      error={error}
      handleLogin={handleLogin}
      resetting={resetting}
      submitting={submitting}
    />
  );
};

export default Login;
